module.exports = __webpack_public_path__ + "static/media/spine-surgery-icon@3x.aa08d7b3.png";